export default __webpack_public_path__ + "static/media/Boomstore3.e956fcb2.png";